import { Image, StyleSheet, View } from 'react-native';
import React, { useEffect, useState } from 'react';
import { useBMTheme } from '../../theme';
import { BMDotLoader } from '../..';
import IcSystemBrokenImage from '@traveloka/district-icon/IcSystemBrokenImage';
const ASPECT_RATIO_MAP = {
    AVATAR: 1,
    '16:9': 16 / 9,
    '3:2': 3 / 2,
};
function BMImageContainerErrorState(props) {
    const { aspectRatio, width, testID } = props;
    const { BMComponents, BMPrimitives } = useBMTheme();
    const getIconSize = () => {
        if (aspectRatio === 'AVATAR')
            return 24;
        else {
            return (width / 200) * 24;
        }
    };
    const iconSize = getIconSize();
    return (<View style={[
            styles.absolute,
            {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: BMPrimitives.BMRadius.sm,
                backgroundColor: BMComponents.BMStyleSurfaceBgcolorDisabled,
            },
        ]} testID={`${testID}-error`}>
      <IcSystemBrokenImage height={iconSize} width={iconSize}/>
    </View>);
}
export default function BMImageContainer({ src, alt, useOverlay, aspectRatio, width, testID }) {
    const { BMPrimitives, BMComponents } = useBMTheme();
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const imgWidth = aspectRatio === 'AVATAR' ? 64 : width;
    const imgAspectRatio = ASPECT_RATIO_MAP[aspectRatio];
    const imgHeight = imgWidth / imgAspectRatio;
    // Reset state if image source is changed
    useEffect(() => {
        setIsLoading(true);
        setIsError(false);
    }, [src]);
    return (<View style={[styles.container, { width: imgWidth, borderRadius: BMPrimitives.BMRadius.sm }]} testID={testID}>
      <Image source={{
            uri: src,
        }} resizeMode="cover" alt={alt} style={{
            width: imgWidth,
            height: imgHeight,
            aspectRatio: imgAspectRatio,
            borderRadius: BMPrimitives.BMRadius.sm,
        }} onLoad={() => setIsLoading(false)} onError={() => {
            setIsLoading(false);
            setIsError(true);
        }}/>
      {isError ? <BMImageContainerErrorState aspectRatio={aspectRatio} width={imgWidth} testID={testID}/> : null}
      {/* TODO: WILL UPDATE WITH BMLazyLoader once the design is ready! */}
      {isLoading ? (<View style={[
                styles.absolute,
                {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: BMPrimitives.BMRadius.sm,
                    backgroundColor: BMComponents.BMStyleSurfaceBgcolorDisabled,
                },
            ]} testID={`${testID}-loading`}>
          <BMDotLoader />
        </View>) : null}
      {useOverlay ? (<View style={[
                styles.absolute,
                {
                    borderRadius: BMPrimitives.BMRadius.sm,
                    backgroundColor: BMComponents.BMStyleOverlaysScrim,
                    zIndex: 2,
                },
            ]} testID={`${testID}-overlay`}/>) : null}
    </View>);
}
const styles = StyleSheet.create({
    container: {
        position: 'relative',
    },
    absolute: {
        width: '100%',
        height: '100%',
        position: 'absolute',
    },
});
